import { Company, CompanyCellData } from '../store/clients/types';

export const filterCompaniesByAssigneeID = (
  companies: Company[],
  currentUserID: string,
) =>
  companies.filter(c =>
    Boolean(
      (c.additionalFields?.assignedUserIDs || {})[currentUserID] ||
        c.fields.leadUserID === currentUserID,
    ),
  );

export const companyCellComparator = (
  a: CompanyCellData,
  b: CompanyCellData,
) => {
  if (a.isPlaceholder) {
    return 1;
  }
  if (b.isPlaceholder) {
    return -1;
  }
  return a.name.localeCompare(b.name);
};
